export const videoMixin = {
  data() {
    return {
      videoDuration: null,
      videoPlaying: false,
      youtubeId: null
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    },
  },
  methods: {
    getVideoLength(duration) {
      const format = (val) => {
        if (val.length < 2) {
          return `0${val}`
        }
        return val
      }
      let seconds = format((Math.floor(duration % 60)).toString())
      let minutes = (Math.floor(duration / 60)).toString()
      const durationFixed = [minutes, seconds].join(':')
      this.videoDuration = durationFixed
    },
    onPlay() {
      this.$emit('click')
      this.player.playVideo()
      this.videoPlaying = true
    },
    onPause() {
      this.videoPlaying = false
    },
    playing() {
      this.videoPlaying = true
    },
    async onReady() {
      const duration = await this.player.getDuration()
      this.getVideoLength(duration)
    }
  },
  watch: {
    videoUrl() {
      this.youtubeId = this.$youtube.getIdFromUrl(this.videoUrl)
    }
  },
  mounted () {
    this.youtubeId = this.$youtube.getIdFromUrl(this.videoUrl)
  }
}